import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { blogService } from '../services';
import { LoadingSpinner } from '../components/ui/Loading';
import PostContent from '../components/blog/PostContent';
import PageContainer from '../components/PageContainer';
import Card from '../components/ui/Card';

const BlogPostDetail = () => {
  const { id } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let active = true;
    setLoading(true);
    blogService.getPost(id)
      .then((data) => { if (active) setPost(data); })
      .catch((e) => { if (active) setError(e.response?.data?.error || 'Erro ao carregar o post'); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [id]);

  if (loading) {
    return (
      <PageContainer title="Post" description="Carregando...">
        <div className="flex justify-center items-center h-64">
          <LoadingSpinner size="lg" />
        </div>
      </PageContainer>
    );
  }

  if (error) {
    return (
      <PageContainer title="Post">
        <Link to="/app/blog" className="text-sm text-purple-300 hover:underline">← Voltar ao blog</Link>
        <div className="mt-4 text-red-400">{error}</div>
      </PageContainer>
    );
  }

  if (!post) return null;

  return (
    <PageContainer title={post.title} description={post.category?.name || 'Sem categoria'}>
      <Link to="/app/blog" className="text-sm text-purple-300 hover:underline">← Voltar ao blog</Link>
      <Card variant="glass" className="mt-4">
        <div className="p-6">
          <PostContent html={post.body} />
        </div>
      </Card>
    </PageContainer>
  );
};

export default BlogPostDetail;
